import { render, staticRenderFns } from "./zb.vue?vue&type=template&id=50c3835b&scoped=true&"
import script from "./zb.vue?vue&type=script&lang=js&"
export * from "./zb.vue?vue&type=script&lang=js&"
import style0 from "./zb.vue?vue&type=style&index=0&id=50c3835b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c3835b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c3835b')) {
      api.createRecord('50c3835b', component.options)
    } else {
      api.reload('50c3835b', component.options)
    }
    module.hot.accept("./zb.vue?vue&type=template&id=50c3835b&scoped=true&", function () {
      api.rerender('50c3835b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schj/zb.vue"
export default component.exports